export default {
    get_fmod: state => { return state.fmod },
    get_ptail: state => { return state.ptail },
    get_pcol: state => { return state.pcol },
    get_col_family: state => { return state.col_family },
    get_reset_stock_list: state => { return state.reset_stock_list },
    get_research: state => { return state.launch_research },
};